import { NgStyle } from '@angular/common';
import { Component, Input, input, OnChanges } from '@angular/core';
import { RouterLink } from '@angular/router';
import { ChatbotConfig } from '@shared/index';
import { getContrastColorSafe } from '@shared-angular';
import { BotService } from '../../services/bot.service';

@Component({
  selector: 'app-bot-icon',
  imports: [RouterLink, NgStyle ],
  standalone: true,
  templateUrl: './bot-icon.component.html',
  styleUrl: './bot-icon.component.scss'
})
export class BotIconComponent implements OnChanges {
  public readonly imageVersion = input<number | undefined>();
  public imageFailed = false;

  public ngOnChanges(): void { this.imageFailed = false; }
  public readonly navigateOnClick = input(true);
  @Input() public botConfig!: ChatbotConfig;
  public getContrastColor = getContrastColorSafe;
  constructor(public botService: BotService) { }
}